<template>
  <lego-modal
    :type="type"
    :visible="isShowModal"
    :size="!size ? 'sm' : size"
    :title="title"
    :content="message"
    :rootId="rootId"
    ref="modal"
    @closed="onCancel()"
    v-if="isShowModal"
  >
    <template #action>
      <lego-button v-if="type === 'confirm'" @click="onCancel"
        >{{ cancelText || t('button.cancel') }}
      </lego-button>
      <lego-button @click="onAction" main>{{ confirmText || t('button.confirm') }}</lego-button>
    </template>
  </lego-modal>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  mixins: [i18nMixin],
  methods: {
    open(type, title, message, action, cancel, size, rootId, cancelText, confirmText) {
      this.el = true;
      this.type = type;
      this.rootId = rootId;
      this.isShowModal = true;
      this.title = title;
      this.message = message;
      this.action = action;
      this.cancel = cancel;
      this.size = size;
      this.cancelText = cancelText;
      this.confirmText = confirmText;
    },
    close() {
      this.isShowModal = false;
    },
    onCancel() {
      this.cancel();
      this.close();
      this.unmount();
    },
    onAction() {
      this.action();
      this.close();
      this.unmount();
    }
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.$refs.modal.$children[0].$el.focus();
  //     setTimeout(() => {
  //       this.$refs.modal.$children[0].$el.focus();
  //     }, 100);
  //   });
  // },
  data() {
    return {
      el: null,
      isShowModal: false,
      title: '',
      message: '',
      size: null,
      action: () => {},
      cancel: () => {},
      unmount: () => {},
      cancelText: '',
      confirmText: '',
      rootId: '',
      type: 'confirm'
    };
  }
};
</script>
